import { Controller } from 'stimulus';
import { createDatepicker } from '@/js/modules/datepicker';

export default class extends Controller {
  connect() {
    this.datepicker = createDatepicker(this.element);
    this.element.addEventListener('changeDate', this.#dispatchNativeChangeEvent);
  }

  disconnect() {
    this.element.removeEventListener('changeDate', this.#dispatchNativeChangeEvent);
    this.datepicker?.destroy();
  }

  #dispatchNativeChangeEvent = () => {
    this.dispatch('change', { prefix: false });
  };
}
